import { render, staticRenderFns } from "./EntityGallery.vue?vue&type=template&id=22aeecbf&scoped=true"
import script from "./EntityGallery.vue?vue&type=script&lang=js"
export * from "./EntityGallery.vue?vue&type=script&lang=js"
import style0 from "./EntityGallery.vue?vue&type=style&index=0&id=22aeecbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aeecbf",
  null
  
)

export default component.exports